module.exports = __webpack_public_path__ + "img/moka-grid.944aeb9c.png";